import { __extends } from "tslib";
import LanguageDetectorNames from "../constants/LanguageDetectorNames";
import ResolvableLanguageElementAttributes from "../constants/ResolvableLanguageElementAttributes";
import AbstractDetector from "./AbstractDetector";
var BodyAttributeDetector = /** @class */ (function (_super) {
    __extends(BodyAttributeDetector, _super);
    function BodyAttributeDetector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The language attributes to look for.
         */
        // private attributes: string[] = ["language", "lang", "data-language", "data-lang"];
        _this.attributes = Object.values(ResolvableLanguageElementAttributes);
        return _this;
    }
    /**
     * The detection logic for this class, returns the language string or null when nothing is found.
     *
     * @returns {(string|null)} The language or null if the detector could note validate the language.
     */
    BodyAttributeDetector.prototype.detect = function () {
        var foundAttribute = this.attributes.find(function (attribute) { return !!document.body.getAttribute(attribute); });
        var language = document.body.getAttribute(foundAttribute);
        return _super.prototype.detect.call(this, language);
    };
    BodyAttributeDetector.prototype.getName = function () {
        return LanguageDetectorNames.BodyAttribute;
    };
    return BodyAttributeDetector;
}(AbstractDetector));
export default BodyAttributeDetector;
//# sourceMappingURL=BodyAttributeDetector.js.map